import {SyncUIActDecorator} from '@gongxigames/framework/slotV2/fsm/acts/decorators/SyncUIActDecorator';
import { slotStore} from '@gongxigames/framework/slotV2/globals';
import {listenUIFeatureStarted, listenUIDisabled} from '@gongxigames/framework/slotV2/ui/acts/utils';
import {SlotSettings} from '@gongxigames/framework/slot';

export class AutoplayDisabledUIAct extends SyncUIActDecorator {
    public execute(): void {
        this.emitter.emit('General.disableSpinButton');
        this.emitter.emit('UI.updateUIElementsState', 'DisabledUIState');

        this.emitter.on('Game.command.round.featureStopped', () => {
            slotStore.batchUpdate({feature_type: null});
        });
        listenUIFeatureStarted(this, this.settings as SlotSettings);
        listenUIDisabled(this);

        this.emitter.on('Game.command.round.uiEnabled', () => {
            slotStore.isDisabledUIMode.value = false;
            this.onExecuted?.();
        });
    }

    getName(): string {
        return 'AutoplayDisabledUIAct';
    }
}